<div class="row g-0 resources-card">
<!-- Close button -->
  <button 
    type="button" 
    class="btn-close position-absolute m-3" 
    aria-label="Close"
    (click)="closeCard()">
  </button>
 
  <div class="col-md-4 p-4 resources-bg d-flex flex-column justify-content-start">
    <h2 class="text-orange fs-4 fw-bold mb-3">Who We Are</h2>
    <p class="text-gray small mb-0">
      Kalpita, an outcome-focused company aimed at delivering unique, reliable, 
      and innovative software solutions using an agile approach to rapid software 
      delivery for small and large-scale businesses.
    </p>
  </div>
  
  <div class="col-md-8 p-4 bg-white">
    <h3>Resources</h3>
    <ul class="list-unstyled mb-0">
      <li><a href="javascript:void(0)" class="dropdown-item" (click)="navigateTo('tech-blogs/blog')">Blog</a></li>
      <li><a href="javascript:void(0)" class="dropdown-item" (click)="navigateTo('kalpita-white-papers/whitepaper')">White Paper</a></li>
      <li><a href="javascript:void(0)" class="dropdown-item" (click)="navigateTo('kalpita-case-studies/case-study')">Case Studies</a></li>
    <!-- <li>
        <a href="#" class="dropdown-item">FAQ</a>
    </li> -->
    <li>
        <a href="javascript:void(0)" class="dropdown-item" (click)="navigateTo('kalpita-press-release/inthenews')">In The News</a>
    </li>
    <li>
        <a href="javascript:void(0)" class="dropdown-item" (click)="navigateTo('kalpita-tech-geek/techgeek')">Tech Geek</a>
    </li>
    </ul>
  </div>
</div>